import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { AdmEquipeService } from 'src/app/shared/api/adm-equipe.service';
import { EquipeService } from 'src/app/shared/api/equipe.service';
import { AdmDashboardService } from 'src/app/shared/api/licencas/adm-dashboard.service';
import { AdmLicencasService } from 'src/app/shared/api/licencas/adm-licencas.service';
import { DashboardService } from 'src/app/shared/api/licencas/dashboard.service';
import { LicencasService } from 'src/app/shared/api/licencas/licencas.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CardModule } from '../../shared/components/card/card.module';
import { ContainerPadraoModule } from '../../shared/components/container-padrao/container-padrao.module';
import { FormularioDinamicoModule } from '../../shared/components/formulario-dinamico/formulario-dinamico.module';
import { LoaderPageModule } from '../../shared/components/loader-page/loader-page.module';
import { TabelaListagemModule } from '../../shared/components/tabela-listagem/tabela-listagem.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { FiltrosDashboardComponent } from './filtros-dashboard/filtros-dashboard.component';
import { LicencasFiltradasService } from './licencas-filtradas-service';

@NgModule({
    declarations: [DashboardComponent, FiltrosDashboardComponent],
    providers: [
        AuthService,
        AdmEquipeService,
        AdmDashboardService,
        DashboardService,
        EquipeService,
        AdmLicencasService,
        LicencasFiltradasService,
        LicencasService
    ],
    imports: [
        CommonModule,
        DashboardRoutingModule,
        MatIconModule,
        ContainerPadraoModule,
        CardModule,
        FormularioDinamicoModule,
        TabelaListagemModule,
        LoaderPageModule
    ]
})
export class DashboardModule { }
